<template>
  <div class="content-error">
    <p class="title">{{ $t("err.occurred.title") }}</p>
    <p class="sub-title">{{ $t("err.occurred.tip") }}</p>
    <el-button type="primary" @click="back">
      {{ $t("err.back") }}
    </el-button>
  </div>
</template>
<script setup lang="ts">
import router from "@/router";

const back = () => {
  console.log(sessionStorage.getItem("previousRoute"));
  router.replace(sessionStorage.getItem("previousRoute") || "/");
};
</script>
<style lang="less" scoped>
.content-error {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.title {
  color: red;
  margin: 10px;
  font-size: 36px;
  font-weight: bolder;
  font-family: "Microsoft YaHei";
  text-shadow: 1px 1px 2px rgb(255, 184, 184);
  letter-spacing: 4px;
}
.sub-title {
  color: red;
  margin: 10px;
  font-size: 20px;
  font-family: "SimHei";
  font-weight: bolder;
  letter-spacing: 1px;
  text-shadow: 1px 1px 2px rgb(255, 184, 184);
}
</style>
